import { useMemo, type PropsWithChildren } from 'react';
import { BlogArticleInlineImage } from './BlogArticleInlineImage';
import { BlogArticleInlineImageContent } from './BlogArticleInlineImageContent';
import { BlogArticleInlineContent } from './BlogArticleInlineContent';
import { cn } from '../../utils/cn';

type BlogArticleInlineProps = PropsWithChildren & {
  variant?: string;
  className?: string;
};

export const BlogArticleInline = ( { className, children, variant = 'dark' }: BlogArticleInlineProps ) => {

  const Components = useMemo( () => {
    return Array.isArray( children ) ? children : [ children ];
  }, [ children ] );

  const Image = Components.find( c => c?.type?.displayName === BlogArticleInlineImage.displayName );
  const ImageContent = Components.find( c => c?.type?.displayName === BlogArticleInlineImageContent.displayName );
  const Content = Components.find( c => c?.type?.displayName === BlogArticleInlineContent.displayName );

  return (
    <div
      className={ cn( 'group flex flex-col gap-5', className ) }
      data-variant={ variant }>
      <div className={ 'relative rounded-[18px] overflow-hidden' }>
        { Image }
        { ImageContent }
      </div>
      { Content }
    </div>
  )
}
BlogArticleInline.displayName = 'BlogArticleInline';
